import { TableAntd } from "components";
import moment from "moment";
import React from "react";

import { useTranslation } from "react-i18next";
import moneyConvert from "utils/moneyConvert";

const dataSource = [
  {
    rank: 1,
    moneyHD: "moneyHD",
    borrower: "borrower",
    date_start: "date_start",
    moneyLoan: "moneyLoan",
    loanBalance: "loanBalance",
    currentLTV: "currentLTV",
    delayDate: "delayDate",
  },
];

interface Props {
  data: any;
}

function TableDateDelay({ data }: Props) {
  const { t } = useTranslation();

  const columns = [
    {
      title: t("DASHBOARD_COL_RANK"),
      dataIndex: "index",
      key: "index",
      render: (value: any, item: any, index: number) => {
        return index + 1;
      },
    },
    {
      title: t("DASHBOARD_COL_MONEY_HD"),
      dataIndex: "contract_number",
      key: "contract_number",
    },
    {
      title: t("DASHBOARD_COL_BORROWER"),
      dataIndex: "name",
      key: "name",
    },
    {
      title: t("DASHBOARD_COL_DATE_START"),
      dataIndex: "contract_start_date",
      key: "contract_start_date",
      render: (data: string) => {
        return moment(data).format("YYYY-MM-DD");
      },
    },
    {
      title: t("DASHBOARD_COL_MONEY_LOAN"),
      dataIndex: "loan_amount",
      key: "loan_amount",
      render: (data: number) => {
        return moneyConvert(data ?? 0, true);
      },
    },
    {
      title: t("DASHBOARD_COL_LOAN_BALANCE"),
      dataIndex: "loan_balance",
      key: "loan_balance",
      render: (data: number) => {
        return moneyConvert(data ?? 0, true);
      },
    },
    {
      title: t("DASHBOARD_COL_CURRENT_LTV"),
      dataIndex: "current_ltv",
      key: "current_ltv",
      render: (data: number) => {
        return moneyConvert(data ?? 0, true);
      },
    },
    {
      title: t("DASHBOARD_COL_DELAY_DATE"),
      dataIndex: "late_payment_date_number",
      key: "delaylate_payment_date_numberDate",
      render: (data: number) => {
        return moneyConvert(data ?? 0, true);
      },
    },
  ];

  return (
    <div className="box-container">
      <TableAntd
        rowKey={(record: any) => record.contract_number}
        columns={columns}
        dataSource={data}
        scroll={{ y: "auto", x: 920 }}
        pagination={false}
        // loading={isLoading}
      />
    </div>
  );
}

export default TableDateDelay;
